import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Footer.scss'

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="footer-content">
        <span className="footer-logo">AH</span>

        <div className="footer-links">
          <a href="https://github.com/elmosuy" target="_blank" rel="noreferrer" aria-label="GitHub">
            <GitHubIcon />
          </a>
          <a href="https://www.linkedin.com/in/elmosuy/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
            <LinkedInIcon />
          </a>
        </div>

        <div className="footer-divider"></div>

        <p className="footer-text">
          Designed & built by <a href="https://github.com/elmosuy" target="_blank" rel="noreferrer">Ayman Haider</a>
          {' '}with <span className="heart">❤</span>
        </p>

        <p className="footer-copyright">
          © {currentYear} All rights reserved
        </p>
      </div>
    </footer>
  );
}

export default Footer;
